import { getGlobalCssVariableValue } from '@disy/lib/dom';

export const MARGIN = parseFloat(getGlobalCssVariableValue('--selection-cart-margin'));

export function getPosition(rect: DOMRect, relativeToRect: DOMRect) {
  return {
    top: rect.top - relativeToRect.top - MARGIN,
    right: relativeToRect.right - rect.right - MARGIN,
    bottom: relativeToRect.bottom - rect.bottom - MARGIN,
    left: rect.left - relativeToRect.left - MARGIN,
  };
}

export function getBounds(selectionCartRect: DOMRect, viewPortWidth: number, viewPortHeight: number) {
  const maxVertical = viewPortHeight - selectionCartRect.height - 2 * MARGIN;
  const maxHorizontal = viewPortWidth - selectionCartRect.width - 2 * MARGIN;
  return {
    minTop: 0,
    minRight: 0,
    minBottom: 0,
    minLeft: 0,
    maxTop: maxVertical,
    maxRight: maxHorizontal,
    maxBottom: maxVertical,
    maxLeft: maxHorizontal,
  };
}

export function getViewPortWithoutScrollSize() {
  const viewPortWidthWithoutScrollWidth =
    window.innerWidth && document.documentElement.clientWidth ?
      Math.min(window.innerWidth, document.documentElement.clientWidth)
    : window.innerWidth || document.documentElement.clientWidth;
  const viewPortHeightWithoutScrollHeight =
    window.innerHeight && document.documentElement.clientHeight ?
      Math.min(window.innerHeight, document.documentElement.clientHeight)
    : window.innerHeight || document.documentElement.clientHeight;
  return [viewPortWidthWithoutScrollWidth, viewPortHeightWithoutScrollHeight];
}
